import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAutoMappingPost } from 'actions/auto-mapping';
import { ACTIONS as notificationActions } from 'actions/notification';
import { closeModal } from 'actions/modal';
import { invalidateMappingLogs } from 'actions/auto-mapping';

const useLogic = ({ showOtherTeachers, mappingId, bestTeacherId, otherTeachers }) => {
  const [isNotGoodMatch, setIsNotGoodMatch] = useState(false);
  const dispatch = useDispatch();
  const [selectedTeacher, setSelectedTeacher] = useState(null);

  const onMappingAssignComplete = errorMessage => {
    if (errorMessage) {
      dispatch({
        type: notificationActions.SHOW_NOTIFICATION,
        payload: {
          text: 'Something went wrong.',
          duration: 10,
          showCloseIcon: true,
        },
      });
    } else {
      invalidateMappingLogs?.();
      dispatch(closeModal?.());
    }
  };

  const { post: autoMappingAssignPost, isProcessing } = useAutoMappingPost({
    onComplete: onMappingAssignComplete,
  });

  useEffect(() => {
    if (bestTeacherId && !showOtherTeachers) {
      setSelectedTeacher(bestTeacherId);
    } else if (showOtherTeachers && otherTeachers?.length === 1) {
      setSelectedTeacher(otherTeachers?.[0]?.id);
    } else {
      setSelectedTeacher(null);
    }
  }, []);

  const handleAssignTeacher = useCallback(() => {
    const data = {
      action: 'ASSIGN',
      mapping_log_id: mappingId,
      teacher_id: selectedTeacher,
    };
    autoMappingAssignPost(data);
  }, [autoMappingAssignPost, mappingId, selectedTeacher]);

  const handleSelectTeacher = id => {
    setSelectedTeacher(id);
  };

  return {
    isNotGoodMatch,
    setIsNotGoodMatch,
    handleAssignTeacher,
    isBusy: isProcessing,
    handleSelectTeacher,
    selectedTeacher,
  };
};

export default useLogic;
